import { FC } from 'react'
import styled from 'styled-components'
import { LandingPageSection } from '@/network/graphql.g'
import Link from '@/components/atoms/link'
import { validFor } from '@/theme/validFor'
import { BigAccentButton } from '@/components/atoms/button'
import { Flex } from '@/components/atoms/Grid'
import { getImageUrlSubcategories } from './getImageUrl'

type ValentineSubCategoriesProps = {
  valentineCategory: LandingPageSection
}

const ValentineSubCategories: FC<ValentineSubCategoriesProps> = ({
  valentineCategory
}) => {
  const valentineCategories = [...valentineCategory.categories].sort(
    (a, b) => a.sort - b.sort
  )

  return (
    <Flex justifyContent="space-between" width="100%" height="100%">
      <StyledFlex
        flexDirection={{ mobile: 'column', tablet: 'row', desktop: 'row' }}
        flexWrap={{ tablet: 'wrap', desktop: 'wrap' }}
      >
        {valentineCategories.map((item) => (
          <StyledWrapper
            sort={item.sort}
            position={valentineCategory.position}
            key={item.sort}
          >
            <StyledLink href={item.link}>
              <StyledValentineButton title={item.name} />
            </StyledLink>
          </StyledWrapper>
        ))}
      </StyledFlex>
    </Flex>
  )
}

export default ValentineSubCategories

const StyledFlex = styled(Flex)`
  width: 100%;
  align-items: flex-end;
  justify-content: space-around;
  margin-bottom: 20px;
`

const StyledWrapper = styled(Flex)`
  background-image: ${(props) =>
    `url(${getImageUrlSubcategories(props.sort, props.position)})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 300px;
  min-width: 295px;
  align-items: center;
  justify-content: center;
  margin: auto;
  ${validFor.desktopWide`
    min-width: 350px;
  `}
  ${validFor.tablet`
    width: 50%; 
    margin: 20px 0; 
    background-size: contain;
  `}

   ${validFor.mobile`
    min-width: 250px;
    margin:auto;
  `}
`

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`

const StyledValentineButton = styled(BigAccentButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.valentineBackgroundButton};
  color: ${(props) => props.theme.colors.background};
  margin-top: 230px;
  width: 200px;
  height: 60px;
  font-size: 14px;
`
